import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=282f830a&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=ts&"
export * from "./EditIcon.vue?vue&type=script&lang=ts&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=282f830a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f830a",
  null
  
)

export default component.exports